import axios from "axios";

const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000/api"
    : "https://panel.corex3.com/api";

const instance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // si usas cookies
});

export default instance;
